export const EVENT_SCHEMA_VERSION = '1.4.0';
export const SIMPLE_UI_SCHEMA_VERSION = '1.5.0';
export const SIMPLE_UI_GUN =
  'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1';
export const SIMPLE_UI_CATEGORY = 'simpleUi';
export const PUBLISHER_ID = 'com.hp.jarvis.hpsmart.datacollection.publisher';
export const ACTIVITY = 'Privacy-v01';
export const SCREEN_PATH = '/ReactPrivacyConsents/';
export const SCREEN_PATH_MANAGE_USER = '/ReactPrivacyConsents/UserConsent/';
export const SCREEN_PATH_MANAGE_PRINTER = '/ReactPrivacyConsents/PrinterConsent/';
export const SCREEN_NAME_USER = 'UserConsent';
export const SCREEN_NAME_PRINTER = 'PrinterConsent';
export const SCREEN_NAME_MANAGE_USER = 'UserManageOptions';
export const SCREEN_NAME_MANAGE_PRINTER = 'PrinterManageOptions';
export const ACTION_AUX_PARAMS_USER = 'source=hpSmartApp&flow=userOnboarding';
export const ACTION_AUX_PARAMS_PRINTER = 'source=hpSmartApp&flow=deviceOnboarding';
export const SCREEN_MODE_SHOWN = 'DeclineOptionalShown';
export const SCREEN_MODE_NOTSHOWN = 'DeclineOptionalNotShown';

// Activity
export const ACTIVITY_PRIVACY_V01 = 'Privacy-v01';

export const SCREEN_PATHS = {
  REACT_PRIVACY_CONSENTS: '/ReactPrivacyConsents/',
  REACT_PRIVACY_CONSENTS_APP_WELCOME: '/ReactPrivacyConsents/AppWelcome/',
  REACT_PRIVACY_CONSENTS_PRINTER_CONSENT: '/ReactPrivacyConsents/PrinterConsent/'
};

export const SCREEN_NAMES = {
  APP_WELCOME: 'AppWelcome',
  APP_MANAGE_OPTIONS: 'AppManageOptions',
  PRINTER_WELCOME: 'PrinterConsent',
  PRINTER_MANAGE_OPTIONS: 'PrinterManageOptions',
  EASY_START_MODIFY_CONSENT: 'EasyStartModifyConsent'
};

export const SCREEN_MODES = {
  DECLINE_ALL_SHOWN: 'DeclineAllShown',
  DECLINE_ALL_NOT_SHOWN: 'DeclineAllNotShown'
};

export const ACTIONS = {
  SCREEN_DISPLAYED: 'ScreenDisplayed',
  CONTROL_DISPLAYED: 'ControlDisplayed',
  CONTROL_BUTTON_CLICKED: 'ControlButtonClicked',
  CONTROL_HYPERLINK_CLICKED: 'ControlHyperLinkClicked',
  CONTROL_TOGGLE_ENABLED: 'ControlToggleEnabled',
  CONTROL_TOGGLE_DISABLED: 'ControlToggleDisabled',
  CLICKED: 'ControlButtonClicked'
};

export const CONTROL_NAMES = {
  ACCEPT_ALL: 'AcceptAll',
  DECLINE_ALL: 'DeclineAll',
  MANAGE_OPTIONS: 'ManageOptions',
  HP_PRIVACY_STATEMENT: 'HpPrivacyStatement',
  AI_TERMS_OF_USE: 'AITermsOfUse',
  TERMS_OF_USE: 'TermsOfUse',
  EULA: 'Eula',
  CONTINUE: 'Continue',
  BACK: 'Back',
  GOOGLE_ANALYTICS: 'GoogleAnalytics',
  ADOBE_ANALYTICS: 'AdobeAnalytics',
  OPTIMIZELY: 'Optimizely',
  PRINTER_ANALYTICS: 'PrinterAnalytics',
  PRINTER_ADVERTISING: 'PrinterAdvertising',
  DATA_TRANSFER: 'DataTransfer',
  APP_ANALYTICS: 'AppAnalytics',
  APP_ADVERTISING: 'AppAdvertising',
  EASY_START_MODIFY_CONSENT_AGREE_BUTTON: 'EasyStartModifyConsentAgree',
  EASY_START_MODIFY_CONSENT_DECLINE_BUTTON: 'EasyStartModifyConsentDecline'
};

export const HYPERLINKS_HREFS = {
  AI_TERMS_OF_USE: 'https://www.hp.com/hp-app-ai-terms-of-use',
  TERMS_OF_USE: 'https://www.hpsmart.com/hpapp-tou-redirect',
  PRIVACY: 'https://www.hp.com/privacy',
  EULA: 'https://www.hp.com/go/sweula'
};

export const HYPERLINKS_URLS_ENDING_PATHS = {
  AI_TERMS_OF_USE: 'hp-app-ai-terms-of-use',
  TERMS_OF_USE: 'hpapp-tou-redirect',
  PRIVACY: 'privacy',
  EULA: 'sweula',
  US_EULA: 'ish_4416646-4390016-16'
};

export const SOURCE_PARAMS = {
  HP_SMART_APP: 'hpSmartApp',
  ADMIN_PORTAL: 'adminPortal',
  INSTANT_INK_PORTAL: 'instantInkPortal'
};

export const FLOW_PARAMS = {
  USER_ONBOARDING: 'userOnboarding',
  DEVICE_ONBOARDING: 'deviceOnboarding',
  WFH: 'WFH',
  EASY_START_MODIFY_CONSENT: 'easyStartModifyConsent'
};

export const ACTION_AUX_PARAMS = {
  SOURCE: SOURCE_PARAMS,
  FLOW: FLOW_PARAMS
};
